import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-telecaller-grid',
  templateUrl: './telecaller-grid.component.html',
  styleUrls: ['./telecaller-grid.component.css']
})
export class TelecallerGridComponent implements OnInit {
  
  prospects;
  Proj:any={};
  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.GetAllTeleUser();
     this.GetAllProspect()
  }

  GetAllTeleUser() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllTeleUser()
      .subscribe(
        (data: any) => {
          this.Proj=data;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetAllProspect() {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllProspects()
      .subscribe(
        (data:any) => {
          this.prospects = data;
          // this.totalItems=data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/prospect/telecaller/telecaller-grid/telecaller-grid.component.ts